<script>
import EditorComponent from '../__components/Editor.vue';
import MixinItem from '../__mixins/item';

export default {
  name: 'FormSelect',
  mixins: [MixinItem],
  components: {
    EditorComponent,
  },
  props: {
    value: {},
  },
  mounted() {
    this.$emit('showLabel', false);
  },
};
</script>
<template>
  <EditorComponent
    :value="value"
    :placeholder="placeholder"
    :disabled="module.disabled"
    :options="module.options"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="$emit('submit', $event)"
  />
</template>
